export default __webpack_public_path__ + "static/media/14-blind.b85ea5dc.png";